import React from 'react';
import { Sparkles, ShoppingBag, CreditCard, Users } from 'lucide-react';

const GerenciamentoCursos: React.FC = () => (
  <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-6">

    {/* Ícone central */}
    <div className="relative mb-8">
      <div className="absolute inset-0 bg-gold-400/20 blur-[32px] rounded-full scale-150" />
      <img src="/icons/course.png" alt="Cursos"
        className="w-24 h-24 object-contain drop-shadow-[0_4px_16px_rgba(212,175,55,0.5)]" />
    </div>

    {/* Título */}
    <h1 className="text-3xl font-black text-gray-900 mb-3 tracking-tight">
      Cursos — Em Breve
    </h1>

    <p className="text-gray-500 max-w-md leading-relaxed mb-10">
      Em breve você poderá cadastrar seus cursos e vendê-los diretamente pela plataforma — 
      sem complicações, com pagamento integrado e seus alunos gerenciados em um só lugar.
    </p>

    {/* Cards de funcionalidades futuras */}
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 max-w-2xl w-full mb-10">
      {[
        { icon: ShoppingBag,  label: 'Venda Direta',       desc: 'Publique e venda seus cursos pela federação'    },
        { icon: CreditCard,   label: 'Pagamento Integrado', desc: 'Receba pagamentos de forma simples e segura'    },
        { icon: Users,        label: 'Gestão de Alunos',    desc: 'Acompanhe matrículas e progresso em tempo real' },
      ].map(({ icon: Icon, label, desc }) => (
        <div key={label}
          className="bg-white rounded-2xl border border-gray-100 shadow-[0_1px_8px_rgba(0,0,0,0.05)] p-5 text-left">
          <div className="w-9 h-9 rounded-xl bg-gold-50 flex items-center justify-center mb-3">
            <Icon className="w-4.5 h-4.5 text-gold-600 w-5 h-5" />
          </div>
          <p className="text-sm font-semibold text-gray-800 mb-1">{label}</p>
          <p className="text-xs text-gray-400 leading-relaxed">{desc}</p>
        </div>
      ))}
    </div>

    {/* Badge */}
    <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-gold-50 border border-gold-200">
     
      <span className="text-sm font-semibold text-gold-700">Novidade em desenvolvimento</span>
    </div>

  </div>
);

export default GerenciamentoCursos;